export default __webpack_public_path__ + "static/media/check.bfdac970.svg";